import styled from "styled-components";
import colors from "../../../assets001/colors.json";

export const Container = styled.div`
  width: 88%;
  margin: 0 auto;
  font-family: "Gilroy-Regular";
  padding-bottom: 3rem;
  @media (max-width: 768px) {
    width: 95%;
  }
`;
export const SmallHeader = styled.p`
  color: #000000;
  font-size: 18px;
`;
export const BigHeader = styled.p`
  color: ${colors.black};
  font-size: 42px;
  margin-top: 8px;
  font-family: "Gilroy-Bold";
`;
export const TabContainer = styled.div`
  width: 100%;
  margin-top: 10px;
  border: 1px solid ${colors.primary};
  border-radius: 20px;
  padding-bottom: 20px;
`;
export const TabLinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: ${(props) => (props.bg ? props.bg : colors.lightGray)};

  /* opacity: 0.6; */
  padding: 8px 18px;
  @media (max-width: 768px) {
    padding: 4px 9px;
  }
  border-radius: ${(props) => (props.brtl ? props.brtl : "20px")}
    ${(props) => (props.brtr ? props.brtr : "20px")}
    ${(props) => (props.brbl ? props.brbl : "0px")}
    ${(props) => (props.brbr ? props.brbr : "0px")};
`;
export const TabLink = styled.div`
  cursor: pointer;
  min-width: ${(props) => (props.minWidth ? props.minWidth : "20%")};
  @media (max-width: 992px) {
  }
  /*  */
  @media (max-width: 768px) {
    width: 48%;
    margin-top: 10px;
  }

  @media (max-width: 576px) {
    width: 100%;
  }
  text-align: center;
  padding: 15px;
  font-family: "Gilroy-Bold";
  background: ${(props) => (props.isActive ? "white" : "")};
  border-radius: 10px;
  border: ${(props) =>
    props.isActive
      ? `1px solid rgba(46, 65, 56, 0.24)`
      : `0px solid white`} !important;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  &:hover {
    color: #000000 !important;
    border-radius: 10px;
    font-size: 15px;
  }
  &:hover > p {
    opacity: 1 !important;
    color: #000000 !important;
  }

  & > p {
    /* color: rgba(0, 0, 0, 0.1) !important; */
    opacity: ${(props) => (props.isActive ? 0.8 : 0.6)} !important;
    font-weight: ${(props) => (props.isActive ? "bold" : "600")} !important;
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0.2rem 0.4rem;
  justify-content: space-around;
`;

export const QuestionLink = styled.div`
  cursor: pointer;
  width: fit-content;
  @media (max-width: 992px) {
  }
  /*  */
  @media (max-width: 768px) {
    /* width: 48%; */
    margin-top: 10px;
  }

  @media (max-width: 576px) {
    /* width: 100%; */
  }
  text-align: center;
  padding: 15px;
  background: ${(props) => (props.isActive ? "white" : colors.primary)};
  color: ${(props) => (props.isActive ? colors.primary : "white")};

  border-radius: 10px;
  border: ${(props) =>
    props.isActive
      ? `1px solid ${colors.primary}`
      : `1px solid white`} !important;
  font-size: ${(props) => (props.isActive ? "16px" : "14px")} !important;
  font-weight: ${(props) => (props.isActive ? "bold" : "600")} !important;

  &:hover {
    background-color: white !important;
    color: ${colors.primary} !important;
    font-size: 16px;
    font-weight: bold;
    border-radius: 10px;
    border: 1px solid ${colors.primary} !important;
    /* font-size: 15px; */
  }
  &:hover > p {
    opacity: 1 !important;
    color: #000000 !important;
    font-size: 16px;
  }

  & > p {
    color: #000000 !important;
    opacity: ${(props) => (props.isActive ? 0.8 : 0.6)} !important;
    font-weight: ${(props) => (props.isActive ? "bold" : "")} !important;
  }
`;

export const TabContent = styled.div``;
export const FormFlex = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: ${(props) => (props.reverse ? "column-reverse" : "column")};
  }
`;
export const FormFlexDiv = styled.div`
  width: ${(props) => props.width || "50%"};
  padding: 4px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DateInputWrapper = styled.div`
  display: flex;
  align-items: center;
  & > .react-datepicker-ignore-onclickoutside {
    color: white !important;
  }
  & > .react-datepicker-wrapper {
    & > .react-datepicker__input-container {
      & > input {
        color: ${(props) => props.color || ""} !important;
        background: ${(props) => props.bg || ""} !important;
        border-color: ${(props) => props.color || ""} !important;
      }
    }
    width: 100%;
    & > select:focus {
      outline: red;
    }
  }
`;
export const DateIconWrapper = styled.div`
  background: ${colors.primary};
  border: ${(props) =>
    props.useBorder ? " 1px solid white" : "none"} !important;
  text-align: center;
  margin-top: 5px;
  line-height: 2.335rem;
  margin-left: -5px;
  z-index: 99;
  padding: 5.5px;
  border-radius: 4px;
`;
export const DatePickerButton = styled.button`
  height: 30px;
  width: 30px;
  margin-right: 7px;
  background: ${colors.primary};
  border: none;
`;
export const DatePickerSelect = styled.select`
  outline: none !important;
  border-color: none !important;
  &:focus {
    border-color: ${colors.lightGray};
  }

  &:active {
    border-color: ${colors.lightGray};
  }

  &:focus-visible {
    border-color: ${colors.lightGray};
  }
`;
export const ImageUploadContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-top: 15px;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;
export const ImageWrapper = styled.div`
  min-width: 30%;
  border-radius: 20px;
  padding-bottom: 10px;
  min-height: 20vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: ${colors.secondary};
  & > img {
    width: 100%;
    border-radius: 0px 0px 0px 0px;
  }

  & > div {
    margin-top: 10px;
    height: 30px;
    width: fit-content;
    border-radius: 0px;
    padding: 5px 9px;
  }
`;
export const AttachmentFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 20px;
  margin-top: 5px;
  @media (max-width: 992px) {
    padding: 3px 10px;
  }
`;
export const AttachmentUploadContainer = styled.div`
  & > img {
    position: absolute;
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -23;
    border-radius: 20px;
    opacity: 0.7;
  }

  position: relative;
  /* background: ${(props) => props.bg || colors.lightGray}; */
  cursor: pointer;
  width: 25%;
  min-height: 20vh;
  /* background: ${colors.lightGray}; */
  color: ${colors.gray};
  border: 1px solid ${colors.lightGray};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 992px) {
    width: 50%;
  }
`;
export const InlineFormDiv = styled.div`
  width: 80%;
  display: flex;
  align-items: end;
  justify-content: space-around;

  @media (max-width: 992px) {
    flex-direction: column;
    width: 90%;
  }
`;
export const AccountSummaryWrapper = styled.div`
  padding-top: ${(props) => props.pt || "20px"};
  width: 100%;
  overflow-x: auto;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #c3c2c2;
    display: none;
  }

  ::-webkit-scrollbar {
    width: 3px;
    height: 7px;
    display: none;
  }
`;
export const ProfileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  width: 100%;
  cursor: pointer;
  background: ${colors.primary};
  color: white;
  border-radius: 20px;
`;
export const TabContentWrapper = styled.div`
  padding: ${(props) => props.pd || "0.8rem 1.2rem"};
  @media (max-width: 768px) {
    padding: ${(props) => props.pd || "0.4rem 0.5rem"};
  }
`;
export const WrapperLeft = styled.div`
  font-weight: bold;
  width: auto;
  font-size: 15px;
  padding: 0px 0.3rem;
`;
export const WrapperCenter = styled.div`
  flex-grow: 1;
  height: 0.21vh;
  background: ${colors.lightGray};
`;
export const WrapperRight = styled(WrapperLeft)`
  text-align: right;
`;
export const InlineLabelGroup = styled.div`
  display: flex;
  align-items: center;
  /* background: red; */
  @media (max-width: 768px) {
    flex-direction: column;
    & > div {
      width: 100%;
    }
  }
`;
export const InlineLabelWrapper = styled.div`
  flex: ${(props) => props.flex};
  padding: 1px 4px;
`;
export const PageWrapper = styled.div`
  width: ${(props) => props.width || "85%"};
  /* background: red; */
  margin: 0 auto;
  padding: 5px 10px;
  @media (max-width: 992px) {
    width: 90%;
  }
`;
export const AccordionText = styled.p`
  font-family: "Gilroy-Bold";
  font-size: 18px;
  color: #2e4138;
`;

export const Input = styled.div`
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
  }
  width: ${(props) => props.width || "60%"};
`;
export const Icon = styled.span`
  position: absolute;
  left: 23px;
  top: 20px;
  @media (max-width: 768px) {
    left: 10px;
  }
`;
export const Search = styled.input`
  background: #f6f4f5b3;
  border: none;
  color: ${colors.primary};
  padding: 10px 50px;
  font-size: 16px;

  @media (max-width: 768px) {
    padding: 13px 20px 13px 32px;
    font-size: 13px;
    font-weight: bold;
  }
  width: 100%;
  height: 47px;
  border-radius: 100px;
  border: 1px solid ${colors.primary};
  ::placeholder {
    color: ${colors.primary};
    font-family: "Gilroy-Regular";
    font-size: 16px;
    @media (max-width: 768px) {
      font-size: 13px;
      font-weight: bold;
    }
    /* color: #000000; */
    /* opacity: 0.6; */
  }
  ::focus {
    border: none;
  }
`;

// chat

export const ChatDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ProfileImgDiv = styled.div`
  display: flex;
  align-items: center;
  background: ${(props) => props.bg || "rgba(83, 156, 8, 0.1)"} !important;
  /* opacity: 0.1; */
  padding: 0.8rem 0.5rem;
  /* border-right: 4px solid ${colors.primary}; */
  border-right: ${(props) =>
    props.hideBorder === true ? "none" : `4px solid ${colors.primary}`};
  & > p,
  & > div {
    font-size: 16px;
    margin-left: 10px;
    font-weight: bold;
  }
`;

export const ImageDiv = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  position: relative;
  & > span {
    height: 12px;
    background: green;
    width: 12px;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    right: 1px;
  }
  & > img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

export const ChatBoxDiv = styled.div`
  padding: 1rem;
  background: ${(props) => props.bg || "#d9d9d9"} !important;
  border-radius: 24px;
  min-height: 40vh;
  max-height: 45vh;
  overflow-y: overlay;

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #c3c2c2;
  }

  ::-webkit-scrollbar {
    width: 3px;
    height: 7px;
  }
`;

export const ChatBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(props) => (props.msgType === "inbox" ? "start" : "end")};
  & > div {
    position: relative;
    max-width: 60%;
    @media (max-width: 768px) {
      max-width: 90%;
    }
    padding: 0.4rem 1.9rem 0.4rem 0.9rem;
    background: ${(props) =>
      props.msgType === "inbox"
        ? props.isStudent === false
          ? "green"
          : colors.primary
        : props.bg || "white"};
    color: ${(props) =>
      props.msgType === "inbox" ? "white" : props.color || colors.primary};
    font-size: 14px;
    line-height: 17px;
    border-radius: ${(props) =>
      props.msgType === "inbox" ? "0px 30px 30px 30px " : "30px 0px 30px 30px"};
    & > span {
      position: absolute;
      right: 6px;
      top: 2px;
    }
  }
  margin-top: 0.5rem;
`;

export const SignatureBox = styled.div`
  /* background: red; */
  margin-top: 4rem;
  width: 100%;
  & > div {
    background: rgba(0, 0, 0, 0.5);
    padding: 10px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 2px;
  }

  & > p {
    margin-top: 5px;
    text-align: center;
    font-family: "Gilroy-Bold";
    font-size: "16px";
    color: #2e4138;
  }
`;

export const LedgerContainer = styled.div`
  min-height: 50vh;
  /* background: red; */
  margin-top: 0.5rem;
  border-radius: 20px;
  border: 1px solid ${colors.primary};
`;

export const LedgerHeader = styled.div`
  background: ${colors.primary};
  width: 100%;
  border-radius: 20px 20px 0px 0px;
  & > div {
    width: fit-content;
    /* background: green; */
    margin: 0 auto;
    padding: 1rem;
    /* background: green; */
    @media (max-width: 768px) {
      /* flex-direction: column; */
      padding: 0.3rem;
      padding-top: 0.5rem;
    }
  }
`;

export const LedgerSchoolName = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  & > div {
    background: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    padding: 6px;
    width: 85px;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: green; */
    @media (max-width: 768px) {
      /* flex-direction: column; */
      padding: 5px;
    }
    & > img {
      width: 80px;
      /* height: 47px; */
      object-fit: cover;
      /* background: green; */
      /* @media (max-width: 768px) {
        width: 44px;
        height: 36px;
      } */
    }
  }

  & > span {
    font-size: 30px;
    color: white;
    text-align: center;
    margin-left: 0.5rem;
    /* background: green; */
    @media (max-width: 768px) {
      /* flex-direction: column; */
      margin-left: 0.2rem;
      font-size: 15px;
    }

    font-weight: bold;
    font-family: "Gilroy-Bold";
  }
`;

export const LedgerSchoolInfo = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    padding: 0.25rem;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
  }
  & > div {
    width: 48%;
    /* background: red; */
    padding: 0.3rem;
    @media (max-width: 768px) {
      /* flex-direction: column; */
      width: 100%;
    }
  }
`;

export const LedgerSchoolHead = styled.div`
  display: inline-flex;
  justify-content: ${(props) => props.justifyContent || "start"};
  align-items: center;
  color: white;
  width: 100%;
  font-size: 15px;
  /* span {
    font-size: 1px;
  } */

  & > div:nth-child(odd) {
    margin-right: 5px;
  }

  & > div {
    height: fit-content !important;
  }
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const LedgerStudentHeader = styled.div`
  padding: 0.8rem;
  border-radius: 20px;
  & > div {
    display: flex;
    border-radius: 20px;
    background: ${colors.secondary};
    border: 1px solid ${colors.primary};
    height: fit-content;
    width: 100%;
    justify-content: center;
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export const LedgerStudentDiv = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  &:nth-child(even) {
    & > div {
      border-left: 1px solid ${colors.lightGray};
      padding-left: 0.4rem;
      @media (max-width: 768px) {
        border-left: none !important;
        padding-left: 0rem !important;
      }
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0.3rem;
  }

  img {
    height: 100%;
    width: 160px;
    border-radius: 20px;
    max-width: -webkit-fill-available;
  }
`;

export const LedgerInfoDetails = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
`;

export const LedgerFlexInfo = styled.div`
  flex: ${(props) => props.flex};

  p {
    font-size: 18px;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: 15px;
    }
  }

  span {
    font-size: 13px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

export const LedgerTable = styled.div`
  padding: 0.8rem;
  width: 100%;
`;

export const ButtonFlex = styled.div`
  display: flex;
  justify-content: space-around;

  button,
  a {
    padding: 6px 11px;
    border-radius: 20px;
    background: white;
    border: 2px solid ${colors.primary};
    outline: none;
    text-decoration: none;
    color: ${colors.primary};
  }

  a:hover {
    color: ${colors.primary} !important;
  }
`;

export const MenuDiv = styled.div`
  /* background: red; */
  /* padding: 1rem;
  background: ${(props) => props.bg || "#d9d9d9"} !important;
  border-radius: 24px; */
  min-height: ${(props) => props.minH || "40vh"};
  max-height: 45vh;
  overflow-y: overlay;

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: ${colors.primary};
    width: 5px;
    height: 6px;
  }

  ::-webkit-scrollbar {
    display: block !important;
    width: 6px;
    height: 7px;
    background-color: white;
  }
`;
